import type { ReadonlyDeep } from 'type-fest';

import { RepresentativeInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

export function representativeForm2ApiMapper(
  representative: ReadonlyDeep<RepresentativeInput>,
): ReadonlyDeep<RepresentativeInput> {
  return pruneInput(representative, RepresentativeInput);
}
